/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Account_Audit_Last_Sign_In_InactiveInputs */

const fr_account_audit_last_sign_in_inactive = /** @type {(inputs: Account_Audit_Last_Sign_In_InactiveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inactif depuis plus de 90 jours`)
};

/**

* @param {Account_Audit_Last_Sign_In_InactiveInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const account_audit_last_sign_in_inactive = /** @type {((inputs?: Account_Audit_Last_Sign_In_InactiveInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Audit_Last_Sign_In_InactiveInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_account_audit_last_sign_in_inactive(inputs)
});